/** Shared session-expiry signaling for API layer + admin polling UIs. */

export const SESSION_EXPIRED_EVENT = 'landsentry:session-expired';

let sessionExpired = false;

export function isSessionExpired() {
  return sessionExpired;
}

export function markSessionExpired() {
  if (sessionExpired) return;
  sessionExpired = true;
  window.dispatchEvent(new CustomEvent(SESSION_EXPIRED_EVENT));
}

export function clearSessionExpired() {
  sessionExpired = false;
}

export function subscribeSessionExpired(listener) {
  const handler = () => listener();
  window.addEventListener(SESSION_EXPIRED_EVENT, handler);
  return () => window.removeEventListener(SESSION_EXPIRED_EVENT, handler);
}

export function isSessionExpiredError(error) {
  return error?.code === 'SESSION_EXPIRED' || error?.sessionExpired === true;
}

export function redirectToLogin() {
  const currentPath = window.location.pathname;
  if (currentPath.includes('/login')) return;

  sessionStorage.setItem('redirectPath', currentPath);
  window.location.href = '/login';
}

export function createSessionExpiredError() {
  const err = new Error('Your session has expired. Please log in again.');
  err.code = 'SESSION_EXPIRED';
  err.sessionExpired = true;
  err.status = 401;
  return err;
}
